import { UserBusinessFeatures } from '../entity/business-features.entity';
export class AUMarket implements UserBusinessFeatures {
  getUserAddressFeatures() {
    return {
      showApartmentBeforeStreet: false,
    };
  }
}
